module.exports = __webpack_public_path__ + "img/wood-01.5677a301.png";